
import dwhExport from '~/dwhExport'
import React, { PureComponent } from "react";
import filter from "lodash/filter";
import get from "lodash/get";
import { Interpolate } from "react-i18next";
import { getLeagueData, getCompetitionMetricPoints } from "../../../../helpers/cwars";
import { isoToFormattedLocalDateTime } from "../../../../helpers/datetime";
import { thousands } from "../../../../helpers/formatting";
import { t, x } from "../../../../helpers/localization";
import settings from "../../../../settings";
import CountDown from "@wg/wows-react-uikit/CountDown";
import {
  Button,
  ButtonSwitch,
  Currency,
  Divider,
  DivTooltip,
  Icon,
  StepCSSTransitionGroup,
  Tooltip,
  TooltipBody,
  ButtonIcon
} from "@wg/wows-react-uikit";
import { COMPETITION_METRIC } from "../../../UIKit/UIKit";
import ProgressBar from "../../ProgressBar/ProgressBar";
import MagnifyingGlass from "../../MagnifyingGlass/MagnifyingGlass";
import ResultsHeader from "../../ResultsHeader/ResultsHeader";
import VersusHeader from "../../VersusHeader/VersusHeader";
import styles from "./MyWarTab.scss";
import MyWarTable from "./MyWarTable/MyWarTable";
import PlayersRatingTable from "./PlayersRatingTable/PlayersRatingTable";
import isEmpty from "lodash/isEmpty";

import { IWarSettings, ICommonInfo, IClanInfo, IStages, Ship, IHistoryRound } from "../../../../Reducers/ReducerClanWars";

export type MyWarTab_Props = {
  currentAccount: any;
  prepageStageTabIndex: number;
  autoParticipation: boolean;
  allPlayersInRatingTable: boolean;
  clanInfo: IClanInfo;
  commonInfo: ICommonInfo;
  warSettings: IWarSettings;
  stages: IStages;
  groupedBattles: [];
  showNationShipTypeStatistic: boolean;
  restriction: null | number;
  nextWeekStartDate: string;
  useAttempts: boolean;
  isFromPort: boolean;
  lastRoundResults: any;
  ships: {
    [shipId: number]: Ship;
  };
  roundsHistory: Array<IHistoryRound>;

  setPrepareStageTab: (prepageStageTabIndex: number) => void;
  toggleAutoParticipation: () => void;
  showNationShipTypeStatistic: (nation: string, type: string) => void;
  showAttemptsModal: (id: string) => void;
  hideAttemptsModal: () => void;
  showCalendarModal: () => void;
  hideCalendarModal: () => void;
  showHistoryModal: () => void;
  hideHistoryModal: () => void;
  togglePlayersCountInRating: () => void;
  setUseAttempts: (val: boolean) => void;
  showLastRoundResults: () => void;
  refreshHistoryModal: () => void;
};
export type MyWarTab_State = {};
class MyWarTab extends PureComponent<MyWarTab_Props, MyWarTab_State> {

  componentDidMount() {

    switch (this.props.stages.currentStage) {
      case 'war': case 'matchmaking':
        this.setWarStageTab();
        break;
      case 'preparation': default:
        this.setPrepareStageTab();

    }
  }

  setPrepareStageTab = () => {
    dwhExport.send('naval_battles.view_preparation')
    this.props.setPrepareStageTab(0);
  };

  setWarStageTab = () => {
    dwhExport.send('naval_battles.view_battle')
    this.props.setPrepareStageTab(1);
  };

  getProgressTarget = (maxClanProgress: number) => {
    switch (this.props.warSettings.stages.preparation.competitionMetric) {

      case COMPETITION_METRIC.EXP:
        {
          return <Interpolate i18nKey={x('Заработайте %(maxClanProgress)s чистого опыта.')} maxClanProgress={thousands(maxClanProgress)} />;
        }

      case COMPETITION_METRIC.DAMAGE:
        {
          return <Interpolate i18nKey={x('Нанесите %(maxClanProgress)s урона.')} maxClanProgress={thousands(maxClanProgress)} />;
        }

      case COMPETITION_METRIC.RIBBONS:
        {
          return <Interpolate i18nKey={x('Заработайте %(maxClanProgress)s лент.')} maxClanProgress={thousands(maxClanProgress)} />;
        }

      default:
        {
          return <Interpolate i18nKey={x('Заработайте %(maxClanProgress)s чистого опыта.')} maxClanProgress={thousands(maxClanProgress)} />;
        }

    }
  };

  renderPreparationContent() {
    const {
      warSettings,
      stages
    } = this.props;
    const settingsPreparation = warSettings.stages.preparation;

    const maxPersonalProgress = settingsPreparation.maxPersonalProgress;
    const maxClanProgress = settingsPreparation.maxClanProgress;
    const personalProgressMilestones = settingsPreparation.personalProgressMilestones;
    const clanProgressMilestones = settingsPreparation.clanProgressMilestones;

    const personalProgress = stages.preparation.personalProgress;
    const clanProgress = stages.preparation.clanProgress;


    return <StepCSSTransitionGroup level={1}>
      <div className={styles.preparationBackground} />
      <div className={styles.progress}>
        <div className={styles.progressBar}>
          <ProgressBar title={t('Задача клана')} target={this.getProgressTarget(maxClanProgress)} mPoints={getCompetitionMetricPoints(this.props.warSettings.stages.preparation.competitionMetric)} myValue={personalProgress} myValueMax={maxPersonalProgress} totalValue={clanProgress} maxValue={maxClanProgress} breakpoints={clanProgressMilestones} competitionMetric={this.props.warSettings.stages.preparation.competitionMetric} />
        </div>
      </div>
    </StepCSSTransitionGroup>;
  }

  renderMatchmakingContent() {
    return <div className={styles.countdown}>
      <StepCSSTransitionGroup level={1}>
        <div className={styles.peaceBackground} />
        <div className={styles.countdownDescriptionWrapper}>
          <span className={styles.countdownDescription}>
            {t('Этап подготовки завершился и для начала битвы мы должны подобрать вам соперника')}
          </span>
          <span className={styles.countdownDescription}>
            {t('А пока вы можете подготовиться к решающей схватке')}
          </span>
        </div>
        <div className={styles.magnifyingGlass}>
          <MagnifyingGlass />
        </div>
        <CountDown date={this.props.warSettings.stages.war.startDate} t={t} />
        <span className={styles.countdownLabel}>{t('До начала битвы')}</span>
      </StepCSSTransitionGroup>
    </div>;
  }

  renderRewardingContent() {
    return <div className={styles.rewarding}>
      <StepCSSTransitionGroup level={1}>
        <div className={styles.peaceBackground} />
        <span className={styles.rewardingText}>{t('Битва завершена. ')}</span>
        <span className={styles.rewardingText}>{t('Идет подведение итогов состязания, подсчет рейтингов и начисление наград. ')}</span>
      </StepCSSTransitionGroup>
    </div>;
  }


  renderWarPreparationContent() {
    const {
      warSettings,
      stages
    } = this.props;
    const settingsPreparation = warSettings.stages.preparation;

    const maxClanProgress = settingsPreparation.maxClanProgress;
    const clanProgress = stages.preparation.clanProgress;

    const preparationProgressIsDone = clanProgress >= maxClanProgress;

    return <div className={styles.countdown}>
      <StepCSSTransitionGroup level={1}>
        <div className={styles.peaceBackground} />
        <div className={styles.countdownDescriptionWrapper} style={{ margin: '0 0 50px 0' }}>
          <span className={styles.countdownDescription}>
            {preparationProgressIsDone ? t('Ваш клан успешно выполнил задачу клана на этапе Подготовки') : t('Для участия в этапе Битва необходимо выполнить задачу клана на этапе Подготовки')}
          </span>
        </div>
        <CountDown date={warSettings.stages.war.startDate} t={t} />
        <span className={styles.countdownLabel}>
          {t('До начала битвы')}
        </span>
      </StepCSSTransitionGroup>
    </div>;
  }

  renderWarContent() {
    const enemy = get(this.props, ['stages', 'war', 'enemy'], null);

    let currentPlayerAttempts = filter(this.props.stages.war.battles, battle => {
      return battle.spaId === this.props.currentAccount.id && !!battle.finishedAt;
    }).length;

    const maxPersonalAttempts = this.props.warSettings.stages.war.maxPersonalAttempts;

    if (currentPlayerAttempts > maxPersonalAttempts) {
      currentPlayerAttempts = maxPersonalAttempts;
    }

    return <div>
      <StepCSSTransitionGroup className={styles.attempts} level={1}>
        <div className={styles.warBackground} />
        <DivTooltip tooltipBody={<TooltipBody>
          {t('Количество использованных вами попыток взятия планки')}
        </TooltipBody>}>
          <span className={styles.attemptsText}>{t('Мои попытки:')}</span>
                        &nbsp;
                        <span className={styles.attemptsCount}>
            {currentPlayerAttempts}/{maxPersonalAttempts}
          </span>

        </DivTooltip>
        <ButtonIcon
          type="clan-info"
          onClick={
            () => {
              this.props.showAttemptsModal(this.props.currentAccount.id)
            }} />
      </StepCSSTransitionGroup>
      <StepCSSTransitionGroup className={styles.switchWrapper} level={1}>
        <span className={styles.useAttempts}>{t('Зачет попыток')}</span>
        <ButtonSwitch value={this.props.commonInfo.personal.settings.isAttemptsCount} onChange={this.props.setUseAttempts} stateTextOn={[t('Включить'), t('Включено')]} stateTextOff={[t('Выключить'), t('Выключено')]} />
      </StepCSSTransitionGroup>
      <StepCSSTransitionGroup className={`${styles.versusHeader} ${styles.blurable} ${this.props.isFromPort ? styles.isBlured : ''}`} level={2}>
        <VersusHeader left={{
          tag: this.props.clanInfo.tag,
          color: this.props.clanInfo.color,
          realm: settings.realm.code,
          score: this.props.commonInfo.clan.starsCount,
          leagueData: getLeagueData(this.props.warSettings.leagues, this.props.commonInfo.clan.league) //@TODO for medal img
        }} right={{
          tag: (enemy && enemy.tag) ? enemy.tag : '-',
          color: (enemy && enemy.color) ? enemy.color : '#fff',
          realm: (enemy && enemy.realm) ? enemy.realm : '-',
          score: (enemy && enemy.starsCount) ? enemy.starsCount : 0,
          leagueData: (enemy && enemy.league) ? getLeagueData(this.props.warSettings.leagues, enemy.league) : getLeagueData(this.props.warSettings.leagues, 1) //@TODO for medal img
        }} />
      </StepCSSTransitionGroup>
      <StepCSSTransitionGroup className={`${styles.blurable} ${this.props.isFromPort ? styles.isBlured : ''}`} level={3}>
        <div>
          <MyWarTable nations={this.props.warSettings.stages.war.nations} grades={this.props.warSettings.stages.war.grades} topGradesIncrement={this.props.warSettings.stages.war.topGradesIncrement} unavailableCells={this.props.warSettings.stages.war.unavailableCells} data={this.props.groupedBattles} competitionMetric={this.props.warSettings.stages.preparation.competitionMetric} onCellClick={this.props.showNationShipTypeStatistic} />

          <Interpolate i18nKey={x('За каждые %(stars)s клан получает %(oil)s')} stars={<Currency amount={this.props.warSettings.stages.war.rewardedStarsIncrement} isBold={true} type="cwars-star" t={t} />} oil={<Currency amount={this.props.warSettings.stages.war.starsIncrementReward.amount} isBold={true} type={this.props.warSettings.stages.war.starsIncrementReward.type} t={t} />} />

        </div>
      </StepCSSTransitionGroup>
      <StepCSSTransitionGroup level={4} className={`${styles.playersRatingTableWrap} ${styles.blurable} ${this.props.isFromPort ? styles.isBlured : ''}`}>
        <div className={styles.divider}>
          <Divider type="major" />
        </div>

        <h2 className={styles.subTitle}>{t('Участники битвы')}</h2>
        <PlayersRatingTable battles={this.props.stages.war.battles} maxPersonalAttempts={maxPersonalAttempts} allPlayersInRatingTable={this.props.allPlayersInRatingTable} togglePlayersCountInRating={this.props.togglePlayersCountInRating} onClick={this.props.showAttemptsModal} />
      </StepCSSTransitionGroup>
    </div>;
  }

  renderRestrictionMessage = () => {

    switch (this.props.restriction) {
      case 0:
        {// ACCOUNT_NOT_IN_CLAN
          return <StepCSSTransitionGroup level={1}>
            <div className={styles.restrictionContentWrapper}>
              <div className={styles.restrictionBackground} />
              <div className={styles.restrictionContent}>
                <span className={styles.restrictionText}>{t('Вы не в клане и поэтому не можете участвовать в текущей Битве')}</span>
              </div>
            </div>
          </StepCSSTransitionGroup>;
        }
      case 1:
        {// ACCOUNT_MISSED_PREPARATION
          return <StepCSSTransitionGroup level={1}>
            <div className={styles.restrictionContentWrapper}>
              <div className={styles.restrictionBackground} />
              <div className={styles.restrictionContent}>
                <span className={styles.restrictionText}>{t('Вы пропустили этап Подготовка и поэтому не можете участвовать в текущей Битве')}</span>
              </div>
            </div>
          </StepCSSTransitionGroup>;
        }
      case 2:
        {// CLAN_MISSED_PREPARATION
          return <StepCSSTransitionGroup level={1}>
            <div className={styles.restrictionBackground} />
            <div className={styles.restrictionContent}>
              <span className={styles.restrictionText}>{t('Ваш клан не участвовал в этапе Подготовка и поэтому не может участвовать в текущей Битве')}</span>
              <div className={styles.nextWeekTimer}>
                <CountDown date={new Date(this.props.nextWeekStartDate)} t={t} />
              </div>
              <span className={styles.timerLabel}>
                {t('До начала следующего морского сражения')}
              </span>
            </div>
          </StepCSSTransitionGroup>;
        }
      case 3:
        {// CLAN_FAILED_PREPARATION
          return <StepCSSTransitionGroup level={1}>
            <div className={styles.restrictionBackground} />
            <div className={styles.restrictionContent}>
              <span className={styles.restrictionText}>{t('Ваш клан не выполнил задачу клана на этапе Подготовка и поэтому не может участвовать в текущей Битве')}</span>
              <div className={styles.nextWeekTimer}>
                <CountDown date={new Date(this.props.nextWeekStartDate)} t={t} />
              </div>
              <span className={styles.timerLabel}>
                {t('До начала следующего морского сражения')}
              </span>
            </div>
          </StepCSSTransitionGroup>;
        }
      case 4:
        {// CLAN_DOES_NOT_PARTICIPATE
          return <StepCSSTransitionGroup level={1}>
            <div className={styles.restrictionContentWrapper}>
              <div className={styles.restrictionBackground} />
              <div className={styles.restrictionContent}>
                <span className={styles.restrictionText}>{t('Ваш клан не участвует в битве')}</span>
              </div>
            </div>
          </StepCSSTransitionGroup>;
        }
      default:
        {
          return null;
        }

    }
  };

  renderTabContent() {
    let tabContent = null;

    switch (this.props.prepageStageTabIndex) {
      case 0:
        {
          tabContent = this.renderPreparationContent();
          break;
        }
      case 1:
        {
          if (this.props.restriction) {
            tabContent = <div>
              {this.renderRestrictionMessage()}
            </div>;

          } else {
            if (this.props.stages.currentStage === 'war') tabContent = this.renderWarContent();

            if (this.props.stages.currentStage === 'matchmaking') tabContent = this.renderMatchmakingContent();

            if (this.props.stages.currentStage === 'preparation') tabContent = this.renderWarPreparationContent();
            if (this.props.stages.currentStage === 'rewarding') tabContent = this.renderRewardingContent();
          }

          break;
        }

      default:
        {
          return null;
        }

    }

    return tabContent;
  }

  renderResultsHeader() {
    return <div className={styles.header}>
      <ResultsHeader medalData={getLeagueData(this.props.warSettings.leagues, this.props.commonInfo.clan.league)} params={[{
        value: thousands(this.props.commonInfo.clan.rating),
        label: t('Рейтинг'),
        tooltipBody: t('Рейтинг клана в режиме Морское Сражение')
      }, {
        value: thousands(this.props.commonInfo.clan.roundsCount),
        label: t('Морские Сражения'),
        tooltipBody: t('Количество битв в которых клан принял участие')
      }, {
        value: thousands(this.props.commonInfo.clan.maxStarsCount),
        label: t('Рекорд'),
        type: 'cwars-star',
        tooltipBody: t('Максимальное количество планок взятых кланом в течении одной битвы')
      }, {
        value: thousands(this.props.commonInfo.clan.totalOilEarned),
        label: t('Награда'),
        type: 'oil',
        tooltipBody: t('Награда полученная кланом за все Морские Сражения')
      }]} />
    </div>;
  }

  renderDateCalendar() {
    const hasLastRoundResult = this.props.lastRoundResults && !isEmpty(this.props.lastRoundResults);
    return <div>
      <Divider type={'major'} />
      <div className={styles.dateRow}>
        <div className={styles.permanentLinkWrapper}>
          <span className={styles.date}>
            <Interpolate i18nKey={x('Морское сражение %(startDate)s - %(endDate)s')} startDate={isoToFormattedLocalDateTime(this.props.warSettings.startDate)} endDate={isoToFormattedLocalDateTime(this.props.warSettings.endDate)} t={t} />
          </span>
        </div>
        <div className={styles.actions}>
          <DivTooltip onClick={this.props.showHistoryModal} className={styles.historyButton} tooltipBody={<Tooltip>
            <TooltipBody>
              {t('История прошедших раундов')}
            </TooltipBody>
          </Tooltip>}>
            {t('История')}
          </DivTooltip>
          <DivTooltip onClick={this.props.showCalendarModal} className={styles.calendarButton} tooltipBody={<Tooltip>
            <TooltipBody>
              {t('Расписание этапов морского сражения')}
            </TooltipBody>
          </Tooltip>}>
            {t('Календарь')}
          </DivTooltip>
        </div>
      </div>
    </div>;
  }

  renderNavTabs() {
    const isPrepareStage = this.props.prepageStageTabIndex === 0;

    return <div className={styles.navTabs}>
      <div className={styles.tabs}>
        <span className={`${styles.navTab} ${isPrepareStage ? styles.active : ''}`} onClick={this.setPrepareStageTab}>
          {t('Подготовка')}
        </span>
        <span className={`${styles.navTab} ${!isPrepareStage ? styles.active : ''}`} onClick={this.setWarStageTab}>
          {t('Битва')}
        </span>
      </div>
    </div>;
  }
  render() {

    if (this.props.stages.currentStage === 'lull') {
      return <div className={styles.wrapper}>
        <StepCSSTransitionGroup className={`${styles.blurable} ${this.props.isFromPort ? styles.isBlured : ''}`} level={1}>
          {this.renderResultsHeader()}
        </StepCSSTransitionGroup>
        <StepCSSTransitionGroup className={`${styles.blurable} ${this.props.isFromPort ? styles.isBlured : ''}`} level={2}>
          <span className={styles.lullTitle}>{t('В данный момент этот вид состязания не доступен')}</span>
        </StepCSSTransitionGroup>
      </div>;
    }

    return <div className={styles.wrapper}>
      <StepCSSTransitionGroup className={`${styles.blurable} ${this.props.isFromPort ? styles.isBlured : ''}`} level={1}>
        {this.renderResultsHeader()}
      </StepCSSTransitionGroup>
      <StepCSSTransitionGroup className={`${styles.blurable} ${this.props.isFromPort ? styles.isBlured : ''}`} level={2}>
        {this.renderDateCalendar()}
      </StepCSSTransitionGroup>
      <StepCSSTransitionGroup className={`${styles.blurable} ${this.props.isFromPort ? styles.isBlured : ''}`} level={3}>
        {this.renderNavTabs()}
      </StepCSSTransitionGroup>
      <StepCSSTransitionGroup level={4}>
        <div className={styles.content}>
          {this.renderTabContent()}
        </div>
      </StepCSSTransitionGroup>
    </div>;
  }
}

export default MyWarTab;